// online_internship_site/src/pages/Contact.js
import React from 'react';
import styles from '../styles/contact.module.css';

function Contact() {
  return (
    <div className={styles.contactContainer}>
      <section className={styles.hero}>
        <h1 className={styles.title}>Get in Touch</h1>
        <p className={styles.subtitle}>
          Have questions about our programs? We're here to help you take the next step in your tech
          career.
        </p>
      </section>

      <div className={styles.formContainer}>
        <form onSubmit={e => e.preventDefault()}>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="name">
              Name
            </label>
            <input type="text" id="name" className={styles.input} placeholder="Your full name" />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              className={styles.input}
              placeholder="Your email address"
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="message">
              Message
            </label>
            <textarea
              id="message"
              className={styles.textarea}
              placeholder="Your message"
            ></textarea>
          </div>

          <button type="submit" className={styles.submitButton}>
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
